export function isClusterType(arg) {
    if (!!arg?.properties?.cluster === true)
        return true;
    return false;
}
export function isPointType(arg) {
    if (arg?.geometry?.type === 'Point')
        return true;
    return false;
}
//# sourceMappingURL=BKJInteractiveMap.types.js.map